import React, {useEffect, useState} from "react";
import {Typography} from "@material-ui/core";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import {useParams} from "react-router";

export default function RegistrationConfirmation() {
    const {id} = useParams();
    const [idVal, setIdVal] = useState(100);
    useEffect(() => {
        if (id) setIdVal(id)
        },[id]);
    return (
        <>
            <section style={{padding: 10, backgroundColor: "#eaeef3"}}>
                <div className="confirmationIcon">
                    <CheckCircleOutlineIcon style={{fontSize: 256}}/>
                </div>
                <Typography variant="h4" align="left" component="h4" gutterBottom
                            style={{paddingLeft: 24, textAlign: 'center', fontWeight: 600}}>
                    Confirmation
                </Typography>
                {!idVal && <Typography variant="h5" align="center" component="h5" gutterBottom style={{margin: 15}}>
                    Account successfully created. An email has been sent with instructions for completing your account
                    activation.
                </Typography>}
                {
                    idVal === "100" &&
                    <Typography variant="h5" align="center" component="h5" gutterBottom style={{margin: 15}}>
                        Account successfully created. An email has been sent with instructions for completing your
                        account activation.
                    </Typography>
                }
                {
                    idVal === "-200" &&
                    <Typography variant="h5" align="left" component="h5" gutterBottom style={{margin: 15}}>
                        Your account already exists and access has been added to FMAP application. Please login at fmap.org to proceed further.
                    </Typography>
                }
            </section>
        </>
    );
}
